module.exports = __webpack_public_path__ + "img/clint-mckoy.9d393f46.jpg";